import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';

const columnHelper = createColumnHelper();

export const EXPANSION_COLUMN_ID = 'table-expansion-column';

export const getExpansionColumn = (isExpanded, onToggle) => columnHelper.display({
  id: EXPANSION_COLUMN_ID,
  header: () => null,
  cell: ({ row }) => {
    const expanded = isExpanded(row.id);
    return (
      <button
        type="button"
        className={`table-row-expander ${expanded ? 'expanded' : ''}`}
        onClick={event => {
          event.stopPropagation();
          onToggle(row.id);
        }}
        aria-label="Expand row"
        aria-expanded={expanded}
      />
    );
  },
  size: 42,
  enableResizing: false,
  enableRowClick: false,
  enableSorting: false,
  enableHiding: false,
});
